import { Well_Gas_Type_Options_Enum } from "gql/api";
import type { GasProperties } from "@/libs/calculations/fluidProperties/d";
import { condensateDensityCalculator as pengRobinson } from "./pengRobinson";
import { condensateDensityCalculator as standing } from "./standing";

// Only wet gas condenses; Peng Robinson or a Standing chain off the dew point.
export function getCondensateDensityLBMFT3(
  gasType: Well_Gas_Type_Options_Enum | null | undefined,
  isPengRobinson: boolean,
  hasGasCompositeValues: boolean,
  gasProperties: GasProperties[],
  condensateSpecificGravity: number,
  condensateApi: number,
  gasSpecificGravity: number,
  oilPhaseGasSolubilitySCFSTB: number,
  pressurePSIA: number,
  temperatureF: number,
  dewPointPressurePSIA: number
): number {
  if (gasType !== Well_Gas_Type_Options_Enum.Wet) {
    return 0;
  }

  if (isPengRobinson || hasGasCompositeValues) {
    return pengRobinson(gasProperties);
  }

  return standing(
    condensateSpecificGravity,
    condensateApi,
    gasSpecificGravity,
    oilPhaseGasSolubilitySCFSTB,
    pressurePSIA,
    temperatureF,
    dewPointPressurePSIA
  );
}
